var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaboratory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5967_44824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.272 38.7403C146.398 37.8655 145.283 37.2691 144.07 37.0265L136.592 35.532C132.492 34.7122 128.237 35.2822 124.498 37.1518L123.501 37.6469C119.762 39.5165 115.507 40.0865 111.407 39.2667L105.357 38.0573C104.346 37.8552 103.3 37.9059 102.313 38.2049C101.326 38.5039 100.428 39.0419 99.6988 39.7711M111.467 2.93481H136.532L133.399 6.06795V22.2725C133.399 23.9343 134.06 25.5279 135.235 26.7028L150.901 42.3685C154.848 46.3162 152.05 53.065 146.467 53.065H101.529C95.9453 53.065 93.1505 46.3162 97.0983 42.3685L112.764 26.7028C113.939 25.5279 114.6 23.9343 114.6 22.2725V6.06795L111.467 2.93481Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5967_44824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratory);
export default __webpack_public_path__ + "static/media/laboratory.a0f3a5d267b69f7806f79f705075f14d.svg";
export { ForwardRef as ReactComponent };